import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const UploadLogo: DocumentNode = gql`
    query UploadLogo($input: UploadLogoInput!) {
        uploadLogo(input: $input) {
            url
        }
    }
`;
